import http from '@/core/http';
import { DOMAIN_SYSTEM_ENUM } from '@toy/utils';
import { IAddAccountAppPrams } from './index.d';
/**
 * 开发者帐号 — 添加
 * @see https://yapi.baibu.la/project/996/interface/api/73186
 *
 * @请求方法: POST
 * @更新时间: 2021-04-2dd5 16:52:32
 */
export const AddAccountInfoApi = (params: IAddAccountAppPrams) => {
  return http.post({
    url: '/manage-app/web/v1/app-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 编辑
export const EditAccountInfoApi = (params: IAddAccountAppPrams) => {
  return http.put({
    url: '/manage-app/web/v1/app-info',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 删除
export const DelAccountInfoApi = (id: string) => {
  return http.put({
    url: `/manage-app/web/v1/app-info/${id}`,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
// 启用/停用
export const UpdateEnableApi = (params: {
  id: string;
  isEnabled: string;
  remark?: string;
}) => {
  return http.put({
    url: '/manage-app/web/v1/app-info/updateEnable',
    data: params,
    loading: true,
    server: DOMAIN_SYSTEM_ENUM.ARSENAL_API,
  });
};
